import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipContentComponent} from './views/tooltip-content/tooltip-content.component';
import {TooltipRendererComponent} from './views/tooltip-renderer/tooltip-renderer.component';
import {TooltipDirective} from './directives/tooltip.directive';
import {CustomerTooltipDirective} from '../customers/directives/customer-tooltip.directive';
import {CustomerTooltipComponent} from '../customers/components/customer-tooltip/customer-tooltip.component';
import {RippleModule} from 'primeng/ripple';
import {FlagModule} from '../flag/flag.module';


@NgModule({
  declarations: [TooltipDirective,
    TooltipContentComponent,
    TooltipRendererComponent,
    CustomerTooltipDirective,
    CustomerTooltipComponent,
  ],
  exports: [
    TooltipDirective,
    TooltipRendererComponent,
    CustomerTooltipDirective,
    RippleModule,
  ],
    imports: [
        CommonModule,
        FlagModule,
    ]
})
export class CustomTooltipModule {
}
